import { createFileRoute } from "@tanstack/react-router";
import { blockListQueryOptions } from "~/features/moderation/api";
import { BlockListTemplate } from "~/features/moderation/BlockListTemplate";

export const Route = createFileRoute("/_authenticated/setting/blocked")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(blockListQueryOptions),
  component: BlockListTemplate,
});
